import { useEffect, useState } from "react";
import { Button } from "@/src/components/ui/button";
import { fetch } from "@/src/lib/fetch";
import { Booking } from "./model";
import { ReminderModal } from "./ReminderModal";
import { CheckBookingModal } from "./CheckBookingModal";
import { CommissionInvoiceModal } from "./CommissionInvoiceModal";

/**
 * Ops action bar under the tabs (v14). Only actions that work today are
 * shown.
 */
export function BookingActionBar({
  booking,
  preBooking,
  onConfirm,
  onCopy,
}: {
  booking: Booking;
  preBooking: boolean;
  onConfirm: () => void;
  onCopy: (text: string) => void;
}) {
  const [crewUrl, setCrewUrl] = useState<string | null>(null);
  const [reminder, setReminder] = useState<"payment_reminder" | "crew_list_reminder" | null>(null);
  const [check, setCheck] = useState(false);
  const [commission, setCommission] = useState(false);
  useEffect(() => {
    if (!booking.hubspotId) return;
    fetch<{ data: { formUrl: string | null } }>(`/api/bookings/${booking.id}/preferences`).then((r: any) => setCrewUrl(r.data?.formUrl ?? null)).catch(() => setCrewUrl(null));
  }, [booking.id, booking.hubspotId]);
  const dealLink = booking.offer?.dealLink && !/undefined/.test(booking.offer.dealLink) ? booking.offer.dealLink : null;
  return (
    <div className="mb-6 flex flex-wrap items-center gap-2">
      {preBooking && (
        <>
          <Button size="sm" onClick={() => setCheck(true)}>Check booking…</Button>
          <Button size="sm" variant="ghost" onClick={onConfirm}>Confirm tab</Button>
          <CheckBookingModal open={check} onClose={() => setCheck(false)} bookingId={booking.id} onChecked={() => window.location.reload()} />
        </>
      )}
      <Button size="sm" variant="outline" onClick={() => setCommission(true)}>Commission invoice…</Button>
      <CommissionInvoiceModal open={commission} onClose={() => setCommission(false)} bookingId={booking.id} />
      {crewUrl && <Button size="sm" variant="outline" onClick={() => setReminder("crew_list_reminder")}>Crew list reminder</Button>}
      <Button size="sm" variant="outline" onClick={() => setReminder("payment_reminder")}>Payment reminder</Button>
      {reminder && <ReminderModal open onClose={() => setReminder(null)} bookingId={booking.id} template={reminder} />}
      {crewUrl && (
        <>
          <Button size="sm" variant="ghost" onClick={() => onCopy(crewUrl)}>Copy crew link</Button>
          <Button size="sm" variant="ghost" onClick={() => window.open(crewUrl, "_blank", "noopener")}>Open crew list</Button>
        </>
      )}
      {dealLink && (
        <Button size="sm" variant="ghost" onClick={() => window.open(dealLink, "_blank", "noopener")}>Open in HubSpot</Button>
      )}
    </div>
  );
}
